import { render } from "./TestIndexView.vue?vue&type=template&id=68bfdb02&scoped=true&lang=true"
import script from "./TestIndexView.vue?vue&type=script&lang=js"
export * from "./TestIndexView.vue?vue&type=script&lang=js"

import "./TestIndexView.vue?vue&type=style&index=0&id=68bfdb02&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bfdb02"]])

export default __exports__